import type { RootState } from '@/app/store';
import type { UserAddress } from '@/types';

const EMPTY_ADDRESSES: UserAddress[] = [];

export const selectAuthStatus = (s: RootState) => s.user.status;
export const selectIsAuthenticated = (s: RootState) => s.user.status === 'authenticated';
export const selectCurrentUser = (s: RootState) => s.user.current;
export const selectAddresses = (s: RootState): UserAddress[] =>
  s.user.status === 'authenticated' ? s.user.addresses : EMPTY_ADDRESSES;
export const selectDefaultAddress = (s: RootState) =>
  selectAddresses(s).find(a => a.isDefault);
export const selectUserInitial = (s: RootState) =>
  s.user.current?.name?.[0]?.toUpperCase() ?? '';
